import React from 'react';

import {ProcessSchemaFieldTableProps} from 'processes/settings/ProcessTaskSchemaEditor';
import {getFieldOptions} from 'registry/field/FieldTableOptionGetters';
import FieldTableRow, {DisablableControl} from 'registry/field/FieldTableRow';
import {getSnapshotFieldDisabledMessage} from 'registry/field/FieldUtil';
import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {StorableSchema} from 'samples/storables/StorableSchemaConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {SchemaInterface} from 'schemas/SchemaConstants';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';
import {getSnapshotFieldLookupConfigModalProps} from 'schemas/SnapshotFieldLookupConfigUtil';

import {TagSchemaSummaryGraphQL} from '../../../graphql-fragments/schemas/tag-schemas/__generated/TagSchemaSummaryGraphQL';

const DISALLOW_DELETE_SCHEMA_FIELDS = 'Workflow schema fields cannot be deleted; they can only be archived.';

export interface ProcessSchemaFieldTableRowProps {
  tagSchemas: Array<TagSchemaSummaryGraphQL>;
  storableSchemas: Array<StorableSchema>;
  assaySchemas: Array<AssaySchema>;
  schemaInterfaces: Array<SchemaInterface>;
  schemaFieldSelectors: Array<SchemaFieldSelector>;
  id: string;
  initialField: SchemaField;
  onCancel: (id: string) => void;
  onEdit: (id: string) => void;
  requestChange: (id: string, fieldWithChanges: SchemaField) => void;
  requestRemove: (id: string) => void;
  ownerUrlId: string;
  registryId?: string | null;
  schema: ProcessSchemaFieldTableProps['schema'];
  isFieldBeingCreated: boolean;
  schemaType?: string;
}

export default function ProcessSchemaFieldTableRow(props: ProcessSchemaFieldTableRowProps): JSX.Element {
  return (
    <FieldTableRow
      {...props}
      availableFieldOptions={getFieldOptions({
        schemaFieldSelectors: props.schemaFieldSelectors,
        storableSchemas: props.storableSchemas,
        tagSchemas: props.tagSchemas,
        schemaInterfaces: props.schemaInterfaces,
        initialField: props.initialField,
        includeSnapshotField: true,
        includeBooleanField: true,
        snapshotFieldDisabledMessage: getSnapshotFieldDisabledMessage(props.schema, props.initialField),
      })}
      lookupConfigModalProps={getSnapshotFieldLookupConfigModalProps(props.schema, props.schemaType)}
      disableControlsWithTooltips={{
        [DisablableControl.DELETE_BUTTON]: props.isFieldBeingCreated ? null : DISALLOW_DELETE_SCHEMA_FIELDS,
      }}
      isUneditable={props.initialField.isUneditable}
      shouldShowSubmissionWarningOnCreate={true}
      schemaId={props.schema?.id ?? null}
    />
  );
}
